import { createVNode as n, mergeProps as o } from "vue";
import p from "../node_modules/@pf-ui/pf-icon-svg/es/asn/AppManageFilledStandard.js";
import d from "../components/PfIcon.js";
const a = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return n(d, o(t, {
    icon: p
  }), null);
};
a.displayName = "AppManageFilledStandard";
a.inheritAttrs = !1;
export {
  a as default
};
